import React from 'react'
import PropTypes from 'prop-types'

import { CardWrapper, CardContent } from '../../../shared/settings/card'
import MySavedCardsTable from './my-saved-cards-table'
import styles from './payment.css'

function PaymentDetails({ activeSubscription }) {
  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        <MySavedCardsTable
          activeSubscription={activeSubscription}
        />
      </CardContent>
    </CardWrapper>
  )
}

PaymentDetails.propTypes = {
  activeSubscription: PropTypes.shape({
    status: PropTypes.string
  }).isRequired
}

export default PaymentDetails
